
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentMethodCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentMethodCategory"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"translationTag"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"moonpayAddPaymentMethod"},"name":{"kind":"Name","value":"moonpayPaymentMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"moonpayWithdrawPaymentMethod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"versions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"onlyLatestVersions"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currency"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"symbol"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"precision"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"transformations"},"value":{"kind":"ListValue","values":[{"kind":"StringValue","value":"logo","block":false}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"urls"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"directWithdrawCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bridgeWithdrawPaymentMethod"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"supportsDepay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportsDirectQr"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportsVirtualAccountAdd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supportsOnrampmoneyDirectWithdraw"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operationMappings"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bridgeAddPaymentMethod"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":621}};
    doc.loc.source = {"body":"query GetPaymentMethodCategory($id: String!) {\n  paymentMethodCategory(id: $id) {\n    id\n    translationTag\n    moonpayAddPaymentMethod: moonpayPaymentMethod\n    moonpayWithdrawPaymentMethod\n    versions(onlyLatestVersions: true) {\n      id\n      currency {\n        id\n        symbol\n        precision\n      }\n    }\n    image(transformations: [\"logo\"]) {\n      id\n      urls\n    }\n    directWithdrawCategory {\n      id\n      bridgeWithdrawPaymentMethod\n    }\n    supportsDepay\n    supportsDirectQr\n    supportsVirtualAccountAdd\n    supportsOnrampmoneyDirectWithdraw\n    operationMappings\n    bridgeAddPaymentMethod\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["GetPaymentMethodCategory"] = oneQuery(doc, "GetPaymentMethodCategory");
        
